import type { HTMLAttributes, ReactNode } from 'react';
import { card } from './Card.css';

export function Card({ children, className, ...rest }: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  // Merge the base card style with any caller-provided className (don't let the
  // spread silently drop the base).
  return <div className={[card, className].filter(Boolean).join(' ')} {...rest}>{children}</div>;
}
